if (!customElements.get('product-countdown-timer')) {
  class ProductCountdownTimer extends HTMLElement {
    connectedCallback() {
      this.duration = Math.max(1, Number.parseInt(this.dataset.duration, 10) || 1);
      this.startedAt = Date.now();
      this.lastDisplayedValue = null;
      this.updateTimer();
      this.interval = window.setInterval(() => this.updateTimer(), 250);
    }

    disconnectedCallback() {
      if (this.interval) window.clearInterval(this.interval);
    }

    updateTimer() {
      const elapsedSeconds = Math.floor((Date.now() - this.startedAt) / 1000);
      const remainingSeconds = this.duration - (elapsedSeconds % (this.duration + 1));

      if (remainingSeconds === this.lastDisplayedValue) return;

      this.lastDisplayedValue = remainingSeconds;
      this.textContent = this.formatTime(remainingSeconds);
      this.setAttribute('data-remaining-seconds', remainingSeconds);
    }

    formatTime(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const paddedMinutes = String(minutes).padStart(2, '0');
      const paddedSeconds = String(seconds).padStart(2, '0');

      if (this.duration >= 3600) {
        return `${String(hours).padStart(2, '0')}:${paddedMinutes}:${paddedSeconds}`;
      }

      return `${paddedMinutes}:${paddedSeconds}`;
    }
  }

  customElements.define('product-countdown-timer', ProductCountdownTimer);
}
